import React from 'react';

import MuiSkeleton from '@material-ui/lab/Skeleton';

export interface SkeletonProps {
  className?: string;
  dataFd?: string;
  variant?: 'text' | 'rect';
}

export function Skeleton({
  className,
  dataFd,
  variant = 'text',
}: SkeletonProps): JSX.Element {
  return (
    <MuiSkeleton data-fd={dataFd} className={className} variant={variant} />
  );
}
